export default __webpack_public_path__ + "static/media/แนะนำเพื่อนรับ3v2.449a33dc.png";